import { useParams } from 'react-router-dom';
import { useGetPaymentConfigLogsByAssetQuery } from '@/services/paymentConfigApi';
import { useGetAssetByIdQuery } from '@/services';
import AuditHistory from '@/components/AuditHistory';

export default function PaymentConfigHistory() {
    const { assetId, id: amcId } = useParams<{ assetId?: string; id?: string }>();

    const { data: asset } = useGetAssetByIdQuery(assetId as string, { skip: !assetId });
    const assetLogs = useGetPaymentConfigLogsByAssetQuery(assetId as string, { skip: !assetId });

    const data = assetLogs.data;
    const isLoading = assetLogs.isLoading;
    const error = assetLogs.error;

    const title = 'Payment Configs History';
    const entityName = asset?.name;
    const backLink = assetId
        ? {
              to: `/amcs/${amcId}/assets/${assetId}/payment-configs`,
              label: 'Back to Payment Configs',
          }
        : undefined;

    return (
        <AuditHistory
            title={title}
            entityName={entityName}
            backLink={backLink}
            data={data}
            isLoading={isLoading}
            error={error as any}
            emptyMessage="No payment configuration history found."
        />
    );
}
